import Vue from 'vue'
import Vuex from 'vuex'
// import WebIM from "@/scripts/WebIM";
import Chat from "./chat/chat";
import FriendModule from "./chat/friendModule";
import Group from "./chat/group";
import Emedia from "./chat/emedia";
import { getStorage, setStorage, removeStorage } from '@/scripts/util.js'
Vue.use(Vuex);
export default new Vuex.Store({
    state: {
        userInfo: JSON.parse(getStorage('userInfo')) || {},
        mapPoint: JSON.parse(getStorage('mapPoint')) || null,
        mapDistrict: JSON.parse(getStorage('mapDistrict')) || {},
        productions: JSON.parse(getStorage('productions')) || [],
        hxLoginId: getStorage('hxLoginId') || '',
        hxIsLogin: false,
        chatId: getStorage('chatId') || '',
        chatType: '',
        serviceInfo: null, //服务站信息
        publishAgain: null, //上一单信息
        createConfig: {}, //发单配置
    },
    mutations: {
        setUserInfo(state, value) {
            setStorage('userInfo', value);
            state.userInfo = value;
        },
        setMapPoint(state, value) {
            setStorage('mapPoint', value);
            state.mapPoint = value;
        },
        setMapDistrict(state, value) {
            setStorage('mapDistrict', value);
            state.mapDistrict = value;
        },
        setProductions(state, value) {
            setStorage('productions', value);
            state.productions = value;
        },
        setHxLoginId(state, value) {
            setStorage('hxLoginId', value);
            state.hxLoginId = value;
        },
        setHxLoginStatus(state, value) {
            setStorage('hxIsLogin', value);
            state.hxIsLogin = value;
        },
        //设置聊天对象
        setChatId(state, value) {
            setStorage('chatId', value);
            state.chatId = value;
        },
        //设置聊天方式
        setChatType(state, value) {
            setStorage('chatType', value);
            state.chatType = value;
        },
        //设置服务站信息
        setServiceInfo(state, value) {
            state.serviceInfo = value;
        },
        setPublishAgain(state, value) {
            state.publishAgain = value;
        },
        setCreateConfig(state, value) {
            state.createConfig = value;
        }
    },
    modules: {
        chat: Chat,
        friendModule: FriendModule,
        group: Group,
        emedia: Emedia,
    }
})